import {
	fetchers,
	generateApiFetcher,
	generateFileUploadFetcher,
} from '../../lib/api-fetcher';
import jwt from '../../lib/jwt';
import config from '../config';

export function getAPIBaseUrl() {
	return config.CLIENT_BASE_API_URL;
}

export function getLoggerAPIBaseUrl() {
	return config.FRONTEND_LOGGER_BASE_API_URL;
}

export const isLoggerEnabled = !config.IS_DEVELOPMENT;

const {
	rxAjaxFetcher,
} = fetchers;
const rxjsApiFetcherUseAuthorization = args => {
	const { headers } = args;

	return rxAjaxFetcher({
		...args,
		headers: {
			...headers,
			Authorization: `Bearer ${jwt.current}`,
		},
	});
};

export const rxjsApiFetcherWithoutAuthorization = generateApiFetcher({
	fetcher: rxAjaxFetcher,
	baseUrl: getAPIBaseUrl(),
	loggerConfig: {
		enable: isLoggerEnabled,
		baseUrl: getLoggerAPIBaseUrl(),
	},
});

export const rxjsApiFetcher = generateApiFetcher({
	fetcher: rxjsApiFetcherUseAuthorization,
	baseUrl: getAPIBaseUrl(),
	loggerConfig: {
		enable: isLoggerEnabled,
		baseUrl: getLoggerAPIBaseUrl(),
	},
});

export const rxjsFileUploadFetcher = generateFileUploadFetcher({
	fetcher: rxjsApiFetcherUseAuthorization,
	baseUrl: getAPIBaseUrl(),
	loggerConfig: {
		enable: isLoggerEnabled,
		baseUrl: getLoggerAPIBaseUrl(),
	},
});
